import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const InsetBlockBodyActions = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-inset-block__actions", className)} {...other}>
      {children}
    </div>
  );
};

InsetBlockBodyActions.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

InsetBlockBodyActions.defaultProps = {
  className: "",
  children: null
};

export default InsetBlockBodyActions;
